/**
 * Builds a full name from first, middle, and last name parts.
 * Filters out empty/null/undefined values to avoid double spaces
 * when middle name is not present.
 */
export function buildFullName(firstName, middleName, lastName) {
  return [firstName, middleName, lastName].filter(Boolean).join(" ");
}

/**
 * Builds a combined legal name from first, middle, last, and suffix parts.
 * Used anywhere bond document generation reads the combined legal-name field.
 */
export function buildPersonLegalName(firstName, middleName, lastName, suffix) {
  return [firstName, middleName, lastName, suffix].filter(Boolean).join(" ");
}
